import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data.user);
        // Clean the URL fragment before navigating
        window.history.replaceState(null, "", window.location.pathname);
        // If the user was originally trying to reach a specific page (e.g. a
        // vendor invite link `/events/{id}`), return them there.
        let target = "/dashboard";
        try {
          const stored = sessionStorage.getItem("post_login_return");
          if (stored && stored.startsWith("/") && !stored.startsWith("/auth/")) {
            target = stored;
          }
          sessionStorage.removeItem("post_login_return");
        } catch (e) { console.debug("post_login_return read failed", e); }
        navigate(target, { replace: true, state: { user: data.user } });
      } catch (e) {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback-loading">
      <div className="text-center">
        <div className="eyebrow mb-3">Signing you in</div>
        <div className="font-serif text-3xl text-app">A moment please…</div>
      </div>
    </div>
  );
}
